import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=53405168&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"
import style0 from "./SettingsView.vue?vue&type=style&index=0&id=53405168&prod&lang=scss"
import style1 from "./SettingsView.vue?vue&type=style&index=1&id=53405168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53405168",
  null
  
)

export default component.exports